const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/boa-get-invoice-lines.action';
            binding.dataActions[actionPath] = require('partner/actions/boa-get-invoice-lines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/boa-search-invoices.action';
            binding.dataActions[actionPath] = require('partner/actions/boa-search-invoices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/check-email-order-confirmation-role.action';
            binding.dataActions[actionPath] = require('partner/actions/check-email-order-confirmation-role.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-client-default-delivery-address.action';
            binding.dataActions[actionPath] = require('partner/actions/get-client-default-delivery-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-client-default-transport.action';
            binding.dataActions[actionPath] = require('partner/actions/get-client-default-transport.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-contacts.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-contacts.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-document-availability.action';
            binding.dataActions[actionPath] = require('partner/actions/get-document-availability.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-document-download-url.action';
            binding.dataActions[actionPath] = require('partner/actions/get-document-download-url.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-po-number.action';
            binding.dataActions[actionPath] = require('partner/actions/get-po-number.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-charges.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-charges.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-promise-date.action';
            binding.dataActions[actionPath] = require('partner/actions/get-promise-date.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-purchase-note.action';
            binding.dataActions[actionPath] = require('partner/actions/get-purchase-note.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-stock-avail-date-json.action';
            binding.dataActions[actionPath] = require('partner/actions/get-stock-avail-date-json.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-stock-avail-date.action';
            binding.dataActions[actionPath] = require('partner/actions/get-stock-avail-date.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-stock-avail-qty.action';
            binding.dataActions[actionPath] = require('partner/actions/get-stock-avail-qty.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-user-info.action';
            binding.dataActions[actionPath] = require('partner/actions/get-user-info.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-warehouse-stock-avail-qty-bulk.action';
            binding.dataActions[actionPath] = require('partner/actions/get-warehouse-stock-avail-qty-bulk.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-warehouse-stock-avail-qty.action';
            binding.dataActions[actionPath] = require('partner/actions/get-warehouse-stock-avail-qty.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };